export enum ZollSupportTicketConstants {
  NOT_IMPLEMENTED = 'zollSupportTicket/NOT_IMPLEMENTED',
  SET_EMAIL_ADDRESS = 'zollSupportTicket/SET_EMAIL_ADDRESS',
  SET_PHONE_NUMBER = 'zollSupportTicket/SET_PHONE_NUMBER',
  SET_QUESTION_OR_PROBLEM = 'zollSupportTicket/SET_QUESTION_OR_PROBLEM',
  SET_SHOW_MODAL = 'zollSupportTicket/SET_SHOW_MODAL',
  SET_IS_LOADING = 'zollSupportTicket/SET_IS_LOADING',
  SET_RESPONSE = 'zollSupportTicket/SET_RESPONSE',
  CREATE_ZOLL_SUPPORT_TICKET = 'zollSupportTicket/CREATE_ZOLL_SUPPORT_TICKET',
  SET_SHOW_SUCCESS_ALERT = 'zollSupportTicket/SET_SHOW_SUCCESS_ALERT',
  SET_TICKET_ID = 'zollSupportTicket/SET_TICKET_ID',
  SET_PREFERRED_CONTACT_METHOD = 'zollSupportTicket/SET_PREFERRED_CONTACT_METHOD',
}
